import styled from 'styled-components';
import { colors, r4, s16, s64 } from '@ardoq/design-tokens';

const LOADER_WIDTH = 94;
const LOADER_HEIGHT = 8;

const LoaderBox = styled.div`
  width: ${LOADER_WIDTH}px;
  height: ${LOADER_HEIGHT}px;
  border-radius: ${r4};
  margin-top: ${s16};
  margin-bottom: ${s64};
  position: relative;
  overflow: hidden;
`;

const MovingBar = styled.div`
  @keyframes loader-move {
    from {
      transform: translateX(-100%);
    }

    to {
      transform: translateX(100%);
    }
  }

  background: ${colors.surfaceBrandStrong};
  border-radius: ${r4};
  height: 100%;
  width: 100%;
  animation-duration: 1.5s;
  animation-name: loader-move;
  animation-iteration-count: infinite;
`;

export const Loader = () => (
  <LoaderBox>
    <MovingBar />
  </LoaderBox>
);
